module.exports = __webpack_public_path__ + "static/media/premierUpgradeVoucher.b41107b2.svg";